import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import StyledName from './StyledName';
import HunderlinedOutputText from '../../HunderlinedOutputText';

const Name = ({name, children, onClick, disabled}) => {
	const props = {};

	let Component = HunderlinedOutputText;

	if (disabled) {
		Component = OutputText;
	} else if (onClick) props.onClick = onClick;

	return (
		<StyledName {...props}>
			{name && (
				<Component h6 ellipsis>
					{name}
				</Component>
			)}
			{children}
		</StyledName>
	);
};

Name.propTypes = {
	name: PropTypes.string,
	onClick: PropTypes.func,
	disabled: PropTypes.bool
};

Name.defaultProps = {
	name: null,
	onClick: null,
	disabled: false
};

export default Name;
